/**
 * Barra superior.
 *
 * Contiene solo cuatro cosas: donde estoy (migas), buscar, con que empresa
 * trabajo y el tema. Nada de barras densas con veinte iconos: lo que no se usa
 * todos los dias vive en la paleta de comandos.
 *
 * En movil se reordena: el selector de empresa baja a una segunda linea, porque
 * saber en que consorcio se esta trabajando es mas importante que ahorrar 40px.
 */

import { Breadcrumbs } from '@/components/shell/Breadcrumbs';
import { usePaletteStore } from '@/components/shell/CommandPalette';
import { CompanySwitcher } from '@/components/shell/CompanySwitcher';
import { IconMenu, IconSearch } from '@/components/shell/icons';
import { Kbd } from '@/components/shell/primitives';
import { ThemeToggle } from '@/components/shell/ThemeToggle';

export function TopBar({
  currentModel,
  currentMenu,
  currentRecordId,
  onOpenSidebar,
}: {
  currentModel: string | null;
  /** Menu por el que se entro (`?menu=`), para que las migas digan la rama real. */
  currentMenu: string | null;
  /** Id del registro abierto, o `"new"` al crear uno. */
  currentRecordId: string | null;
  onOpenSidebar: () => void;
}) {
  const abrirPaleta = usePaletteStore((estado) => estado.setOpen);
  const trailing =
    currentRecordId === null ? undefined : currentRecordId === 'new' ? 'Nuevo' : `#${currentRecordId}`;

  return (
    <header className="sticky top-0 z-30 border-b border-line bg-app/85 backdrop-blur supports-[backdrop-filter]:bg-app/70">
      <div className="flex h-topbar items-center gap-2 px-3 sm:px-5">
        <button
          type="button"
          onClick={onOpenSidebar}
          className="grid h-10 w-10 shrink-0 place-items-center rounded-md text-fg-muted transition-colors hover:bg-fg/5 hover:text-fg lg:hidden"
          aria-label="Abrir menú de navegación"
        >
          <IconMenu className="h-5 w-5" />
        </button>

        <div className="min-w-0 flex-1">
          <Breadcrumbs
            currentModel={currentModel}
            currentMenu={currentMenu}
            {...(trailing === undefined ? {} : { trailing })}
          />
        </div>

        <button
          type="button"
          onClick={() => {
            abrirPaleta(true);
          }}
          className="flex h-9 items-center gap-2 rounded-md border border-line bg-surface px-2.5 text-sm text-fg-faint transition-colors hover:border-line-strong hover:text-fg-muted"
          aria-label="Buscar pantallas y acciones (Ctrl+K)"
        >
          <IconSearch className="h-4 w-4" />
          <span className="hidden lg:inline">Buscar…</span>
          <span className="hidden lg:flex lg:items-center lg:gap-1">
            <Kbd>Ctrl</Kbd>
            <Kbd>K</Kbd>
          </span>
        </button>

        <div className="hidden w-56 shrink-0 sm:block">
          <CompanySwitcher />
        </div>

        <ThemeToggle />
      </div>

      {/* En movil la empresa activa ocupa su propia linea: es contexto critico. */}
      <div className="border-t border-line px-3 py-2 sm:hidden">
        <CompanySwitcher />
      </div>
    </header>
  );
}
